import React, { useState } from 'react'
import { ReactComponent as FirstpC } from './FirstP_Clear.svg'
import { ReactComponent as SecondpC } from './SecondP_Clear.svg'
import { ReactComponent as ThirdpC } from './ThirdP_Clear.svg'
import { ReactComponent as FourthpC } from './FourthP_Clear.svg'
import { ReactComponent as FifthpC } from './FifthP_Clear.svg'
import { ReactComponent as SixthpC } from './SixthP_Clear.svg'
import firstpJson from './firstP.json'
import secondpJson from './secondP.json'
import thirdpJson from './thirdP.json'
import fourthpJson from './fourthP.json'
import fifthpJson from './fifthP.json'
import sixthpJson from './sixthP.json'
import emailjs from '@emailjs/browser';
import html2canvas from 'html2canvas'; // if you want screenshot
import { ref, uploadString, getDownloadURL } from "firebase/storage";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { storage, db } from './firebaseConfig';

import { query, where, orderBy, limit, getDocs } from "firebase/firestore";
import { uploadBytes } from 'firebase/storage';

const allJsons = [firstpJson, secondpJson, thirdpJson, fourthpJson, fifthpJson, sixthpJson];

const extractUniqueClasses = () => {
    const uniqueClasses = new Set();

    allJsons.forEach(json => {
        json.colorCode.forEach(color => {
            color.class.forEach(className => {
                uniqueClasses.add(className);
            });
        });
    });

    return Array.from(uniqueClasses);
};

const existingClasses = extractUniqueClasses();
localStorage.setItem('existingClasses', JSON.stringify(existingClasses));

function FullScreenGrid() {
    const [grid, setGrid] = useState(null)
    const [selectedColor, setSelectedColor] = useState(null);
    const [selectedClass, setSelectedClass] = useState(null);
    const [email, setEmail] = useState(localStorage.getItem('email') || '');
    const [status, setStatus] = useState(localStorage.getItem('status') || '');
    const [uploadInProgress, setUploadInProgress] = useState(false);


    const uploadGridHTMLAndSave = async () => {
        const email = localStorage.getItem('email');
        if (!email) return console.log('No email found');

        const gridElement = document.querySelector('.full-screen-grid');
        if (!gridElement) return console.log('No grid element found');

        try {
            // 1. Get the full HTML content of your grid
            const htmlContent = `
            <!DOCTYPE html>
            <html lang="en">
            <head>
              <meta charset="UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
              <title>Your Pixel Grid</title>
              <style>
                body { margin: 0; padding: 20px; background: ${selectedColor || 'white'}; }
                .full-screen-grid { transform: none; transform-origin: top left; }
                /* Add any additional styles if needed */
                .show { opacity: 1; }
              </style>
            </head>
            <body>
              ${gridElement.outerHTML}
            </body>
            </html>
          `;

            // 2. Create a Blob
            const blob = new Blob([htmlContent], { type: 'text/html' });

            // 3. Upload the Blob (not with FileReader, just upload directly)
            const storageRef = ref(storage, `gridhtml/${Date.now()}.html`);
            await uploadBytes(storageRef, blob);

            // 4. Get the download URL
            const downloadURL = await getDownloadURL(storageRef);

            console.log('HTML uploaded successfully:', downloadURL);

            // 5. Send the link via email
            await sendGridAsEmail(downloadURL);
            localStorage.setItem('status', 'sent');
            // 6. Save record to Firestore
            await addDoc(collection(db, "grid_uploads"), {
                email: email,
                gridUrl: downloadURL,
                timestamp: serverTimestamp(),
            });

            console.log('Email Sent + HTML Saved!');

        } catch (error) {
            console.error('Error uploading HTML:', error);
        }
    };


    const handleColorAndClassChange = () => {
        const storedColor = localStorage.getItem('selectedColor');
        const storedClass = JSON.parse(localStorage.getItem('selectedClass'));

        if (storedColor) {
            setSelectedColor(storedColor);
        }

        if (storedClass) {
            setSelectedClass(storedClass);
            const applyClassToggle = () => {
                existingClasses.forEach((className) => {
                    const elements = document.querySelectorAll(`.${className}C`);
                    if (storedClass.includes(className)) {
                        elements.forEach(element => {
                            element.classList.add('show');
                        });
                    } else {
                        elements.forEach(element => {
                            element.classList.remove('show');
                        });
                    }
                });
            };

            // Run after the elements are rendered
            setTimeout(applyClassToggle, 3);
        }
    };

    React.useEffect(() => {
        const handleStorageChange = () => {
            handleColorAndClassChange();
        };

        // Initial load
        if (grid !== null) {
            handleColorAndClassChange();
        }

        // Add event listener for storage changes
        window.addEventListener('storage', handleStorageChange);

        // Cleanup event listener on unmount
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [grid]);

    React.useEffect(() => {
        
        const handleStorageChange = async () => {
            if (uploadInProgress) return; // Alre
            const storedGrid = localStorage.getItem('grid');
            const email = localStorage.getItem('email');
            const status = localStorage.getItem('status');
            if (storedGrid) {
                setGrid(storedGrid);
            }
            if (email) {
                setEmail(email);
            }
            if (status) {
                if (status === 'sent') {
                    console.log('Email sent successfully!');
                }
                else if (status === 'sending') {
                    setUploadInProgress(true);
                    await uploadGridHTMLAndSave();
                    
                    localStorage.setItem('status', 'sent');
                    setStatus('sent');
                    setUploadInProgress(false);

                }
                setStatus(status);
            }
        };

        // Initial load
        handleStorageChange();

        // Add event listener for storage changes
        window.addEventListener('storage', handleStorageChange);

        // Cleanup event listener on unmount
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    const sendGridAsEmail = async (link) => {
        const email = localStorage.getItem('email');
        if (!email) {
            console.error('No email found in localStorage');
            return;
        }

        const gridElement = document.querySelector('.full-screen-grid');
        if (!gridElement) {
            console.error('Grid element not found');
            return;
        }

        try {
            // OPTION 1: Get HTML
            //   const uploadsRef = collection(db, "grid_uploads");
            //   const q = query(
            //     uploadsRef,
            //     where("email", "==", email),
            //     orderBy("timestamp", "desc"),
            //     limit(1)
            //   );

            //   const querySnapshot = await getDocs(q);

            //   if (querySnapshot.empty) {
            //     console.error('No grid found for this email');
            //     alert('No uploaded grid found for this email.');
            //     return;
            //   }

            //   const latestDoc = querySnapshot.docs[0].data();
            //   const gridUrl = latestDoc.gridUrl;

            //   console.log('Fetched Grid URL:', gridUrl);

            // 2. Now Send Email via EmailJS
            const templateParams = {
                email: email,
                image_grid: link,
            };

            const serviceID = 'service_wl37sco';
            const templateID = 'template_ogctmzh';
            const publicKey = '5cyF54E0QQyNuQIl_'; // from EmailJS Dashboard
            console.log('Sending email with params:', templateParams);
            const result = await emailjs.send(serviceID, templateID, templateParams, publicKey);

            console.log('Email sent successfully:', result.text);
            
        } catch (error) {
            console.error('Failed to send email:', error);
            
        }
    };






    return (
        <div className="full-screen-grid" style={{ transform: 'scale(0.33)', width: '100vw', height: '100vh', top: 0, left: 0, zIndex: 9999, backgroundColor: selectedColor, transformOrigin: 'left top' }}>
            {(!grid || grid == 'sixth') && (<div className="grid zero" style={{ display: 'flex', gap: '0' }}>
                {Array.from({ length: 8 }).map((_, rowIndex) => (
                    <div key={rowIndex} className="grid-row" style={{ display: 'flex', flexDirection: 'column', gap: '0', marginRight: "0px" }}>
                        {Array.from({ length: 5 }).map((_, colIndex) => (
                            <SixthpC key={`${rowIndex}-${colIndex}`} style={{ width: "680px", height: '680px', margin: '0', marginTop: '0px' }} />
                        ))}
                    </div>
                ))}
            </div>)}
            {(grid == 'first') && (<div className="grid one" style={{ display: 'flex', gap: '0' }}>
                {Array.from({ length: 8 }).map((_, rowIndex) => (
                    <div key={rowIndex} className="grid-row" style={{ display: 'flex', flexDirection: 'column', gap: '0', marginRight: "-65px" }}>
                        {Array.from({ length: 5 }).map((_, colIndex) => (
                            <FirstpC key={`${rowIndex}-${colIndex}`} style={{ width: "680px", height: '680px', margin: '0', marginTop: colIndex != 0 && '-65px' }} />
                        ))}
                    </div>
                ))}
            </div>)}
            {(grid == 'second') && (<div className="grid two" style={{ display: 'flex', gap: '0' }}>
                {Array.from({ length: 8 }).map((_, rowIndex) => (
                    <div key={rowIndex} className="grid-row" style={{ display: 'flex', flexDirection: 'column', gap: '0', marginRight: "0px" }}>
                        {Array.from({ length: 5 }).map((_, colIndex) => (
                            <SecondpC key={`${rowIndex}-${colIndex}`} style={{ width: "680px", height: '680px', margin: '0', marginTop: '0px' }} />
                        ))}
                    </div>
                ))}
            </div>)}
            {(grid == 'third') && (<div className="grid three" style={{ display: 'flex', gap: '0' }}>
                {Array.from({ length: 8 }).map((_, rowIndex) => (
                    <div key={rowIndex} className="grid-row" style={{ display: 'flex', flexDirection: 'column', gap: '0', marginRight: "0px" }}>
                        {Array.from({ length: 5 }).map((_, colIndex) => (
                            <ThirdpC key={`${rowIndex}-${colIndex}`} style={{ width: "680px", height: '680px', margin: '0', marginTop: '0px' }} />
                        ))}
                    </div>
                ))}
            </div>)}
            {(grid == 'fourth') && (<div className="grid four" style={{ display: 'flex', gap: '0' }}>
                {Array.from({ length: 8 }).map((_, rowIndex) => (
                    <div key={rowIndex} className="grid-row" style={{ display: 'flex', flexDirection: 'column', gap: '0', marginRight: "0px" }}>
                        {Array.from({ length: 5 }).map((_, colIndex) => (
                            <FourthpC key={`${rowIndex}-${colIndex}`} style={{ width: "680px", height: '680px', margin: '0', marginTop: '0px' }} />
                        ))}
                    </div>
                ))}
            </div>)}
            {(grid == 'fifth') && (<div className="grid five" style={{ display: 'flex', gap: '0' }}>
                {Array.from({ length: 8 }).map((_, rowIndex) => (
                    <div key={rowIndex} className="grid-row" style={{ display: 'flex', flexDirection: 'column', gap: '0', marginRight: "0px" }}>
                        {Array.from({ length: 5 }).map((_, colIndex) => (
                            <FifthpC key={`${rowIndex}-${colIndex}`} style={{ width: "680px", height: '680px', margin: '0', marginTop: '0px' }} />
                        ))}
                    </div>
                ))}
            </div>)}

        </div>
    )
}

export default FullScreenGrid